export const LOCATION_CHANGE = '@@router/LOCATION_CHANGE'
export const PAGINATION_CHANGE_PAGE = 'table/PAGINATION_CHANGE_PAGE'
export const PAGINATION_CHANGE_ROWS_PER_PAGE = 'table/PAGINATION_CHANGE_ROWS_PER_PAGE'
export const SEARCH_ON_CHANGE = 'table/SEARCH_ON_CHANGE'

export const DEFAULT_PAGINATION_PAGE = 0
export const DEFAULT_ROWS_PER_PAGE = 25

export const SEARCH_QUERY_PARAM = {
  user: 'email',
  group: 'name'
}

const initialState = {
  paginationPage: {
    user: DEFAULT_PAGINATION_PAGE,
    group: DEFAULT_PAGINATION_PAGE,
    role: DEFAULT_PAGINATION_PAGE,
    permission: DEFAULT_PAGINATION_PAGE,
    userGroups: DEFAULT_PAGINATION_PAGE,
    groupUsers: DEFAULT_PAGINATION_PAGE,
    groupRoles: DEFAULT_PAGINATION_PAGE
  },
  paginationRowsPerPage: {
    user: DEFAULT_ROWS_PER_PAGE,
    group: DEFAULT_ROWS_PER_PAGE,
    role: DEFAULT_ROWS_PER_PAGE,
    permission: DEFAULT_ROWS_PER_PAGE,
    userGroups: DEFAULT_ROWS_PER_PAGE,
    groupUsers: DEFAULT_ROWS_PER_PAGE,
    groupRoles: DEFAULT_ROWS_PER_PAGE
  },
  searchValues: {
    user: '',
    group: ''
  }
}

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case PAGINATION_CHANGE_PAGE:
      return {
        ...state,
        paginationPage: { ...state.paginationPage, [action.pageType]: action.paginationPage }
      }
    case PAGINATION_CHANGE_ROWS_PER_PAGE:
      return {
        ...state,
        paginationPage: { ...state.paginationPage, [action.pageType]: 0 },
        paginationRowsPerPage: { ...state.paginationRowsPerPage, [action.pageType]: action.paginationRowsPerPage }
      }
    case SEARCH_ON_CHANGE:
      return {
        ...state,
        searchValues: { ...state.searchValues, [action.pageType]: action.value }
      }
    default:
      return state
  }
}

export const paginationChangePage = (pageType, paginationPage) => ({ type: PAGINATION_CHANGE_PAGE, pageType, paginationPage })

export const paginationChangeRowsPerPage = (pageType, paginationRowsPerPage) => ({ type: PAGINATION_CHANGE_ROWS_PER_PAGE, pageType, paginationRowsPerPage })

export const searchOnChange = (pageType, value) => ({ type: SEARCH_ON_CHANGE, pageType, value })

export default reducer
